/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const stocks = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M1.75 1a.75.75 0 0 0-1.5 0h1.5ZM1 15H.25c0 .414.336.75.75.75V15Zm14 .75a.75.75 0 0 0 0-1.5v1.5ZM5 8l.253-.706a.75.75 0 0 0-.798.19L5 8Zm1.688.604.66-.358a.75.75 0 0 0-.407-.348l-.253.706Zm1.206 2.215-.659.359a.75.75 0 0 0 1.35-.07l-.691-.289Zm5.208-1.617-.702.264a.75.75 0 0 0 1.375.068l-.673-.332Zm2.57-3.515a.75.75 0 1 0-1.345-.663l1.346.663ZM4.748 8.707l1.689.603.505-1.412-1.688-.604-.506 1.412Zm1.283.256 1.205 2.215 1.318-.717-1.206-2.215-1.317.717Zm7.745.57 1.898-3.846-1.346-.663L12.43 8.87l1.345.664ZM11.14 2.556a.183.183 0 0 1-.183.183v1.5c.93 0 1.683-.754 1.683-1.683h-1.5Zm-.183.183a.183.183 0 0 1-.184-.183h-1.5c0 .93.754 1.683 1.684 1.683v-1.5Zm-.184-.183c0-.102.082-.184.184-.184v-1.5c-.93 0-1.684.754-1.684 1.684h1.5Zm.184-.184c.1 0 .183.082.183.184h1.5c0-.93-.754-1.684-1.683-1.684v1.5ZM.25 1v11.227h1.5V1H.25Zm0 11.227V15h1.5v-2.773H.25ZM1 15.75h9.956v-1.5H1v1.5Zm9.956 0H15v-1.5h-4.044v1.5Zm-.75-12.261V15h1.5V3.489h-1.5Zm-8.661 9.253 4-4.226-1.09-1.032-4 4.227 1.09 1.031Zm7.04-1.634 3.063-7.33-1.384-.578-3.062 7.33 1.384.578Zm1.668-7.355L12.4 9.466l1.404-.528-2.146-5.713-1.404.528Z"
    />
  </svg>
)
export default stocks
